import { Box } from "@chakra-ui/react";
import blink from "src/styling/animations/blink";

const BlinkingDot = ({ p = "4px", bg = "#82d023" }) => (
  <Box
    p={p}
    bg={bg}
    borderRadius="100%"
    animation={`${blink} 2400ms ease-in-out infinite normal`}
  />
);

export default BlinkingDot;
